import { render } from "./AccountDetails.vue?vue&type=template&id=3b4571b4&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"

import "./AccountDetails.vue?vue&type=style&index=0&id=3b4571b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4571b4"]])

export default __exports__